import ReactDOM from "react-dom/client";
import KeycloakProvider from "./auth/KeycloakProvider";
import "./index.css";
import "./ImportData.css";
import { Provider } from "react-redux";
import { store } from "./stores/Store";
import App from "./App";
import "react-datasheet-grid/dist/style.css";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./utils/QueryClient";
import { suppressResizeObserverLoopError } from "./utils/suppressResizeObserverLoopError";

suppressResizeObserverLoopError();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <KeycloakProvider>
        <App />
      </KeycloakProvider>
    </Provider>
  </QueryClientProvider>
);
